// Helpers dla meczów fazy pucharowej (cup_knockout) rozstrzyganych
// po dogrywce i/lub rzutach karnych.

const hasValue = (v) => v !== null && v !== undefined && v !== '';

// Czy mecz zweryfikowano jako walkower (jedno- lub dwustronny).
export const isWalkover = (match) =>
    match?.walkover === 'home' || match?.walkover === 'away' || match?.walkover === 'both';

// Etykieta walkoweru do wyświetlenia pod wynikiem ('' gdy mecz normalny).
export const getWalkoverLabel = (match) => {
    if (match?.walkover === 'both') return 'walkower obustronny';
    if (match?.walkover === 'home' || match?.walkover === 'away') return 'walkower';
    return '';
};

// Czy dla danego meczu wpisano wynik serii rzutów karnych.
export const hasPenalties = (match) =>
    hasValue(match?.home_penalties) && hasValue(match?.away_penalties);

// Wyznacza zwycięzcę meczu pucharowego (tylko do wyświetlenia).
// Zwraca 'home' | 'away' | null (gdy brak rozstrzygnięcia lub niekompletny wynik).
export const getKnockoutWinner = (match) => {
    if (!match) return null;
    const hg = match.home_goals;
    const ag = match.away_goals;
    if (!hasValue(hg) || !hasValue(ag)) return null;

    if (Number(hg) > Number(ag)) return 'home';
    if (Number(ag) > Number(hg)) return 'away';

    // Remis po regulaminowym czasie / dogrywce → decydują karne
    if (hasPenalties(match)) {
        if (Number(match.home_penalties) > Number(match.away_penalties)) return 'home';
        if (Number(match.away_penalties) > Number(match.home_penalties)) return 'away';
    }
    return null;
};

// Linie adnotacji pod wynikiem (każda w osobnym wierszu), np.:
//   ["po dogrywce"] | ["karne: 5 - 4"] | ["po dogrywce", "karne: 5 - 4"]
// Pusta tablica dla zwykłego rozstrzygnięcia w regulaminowym czasie.
export const getKnockoutAnnotationLines = (match) => {
    if (!match) return [];
    const lines = [];
    if (match.after_extra_time) lines.push('po dogrywce');
    if (hasPenalties(match)) {
        lines.push(`karne: ${match.home_penalties} - ${match.away_penalties}`);
    }
    return lines;
};
